const breakoutRoom = (state = { rooms: [], users: [], settings: {}, timeLimit: 10 }, action) =>
{
	switch (action.type)
	{
		case 'SET_BREAKOUT_ROOMS':
		{
			const { rooms } = action.payload;

			return { ...state, rooms };
		}

		case 'UPDATE_ROOM_USERS':
		{
			const { users }	 = action.payload;

			return { ...state, users };
		}

		case 'REMOVE_BREAKOUT_ROOM':
		{
			const { roomId } = action.payload;

			return { ...state, rooms: state.rooms.filter((el) => el.id !== roomId) };
		}

		case 'ADD_BREAKOUT_ROOM':
		{
			const { room } = action.payload;

			return { ...state, rooms: [ ...state.rooms, room ] };
		}

		case 'JOIN_BREAKOUT_ROOM':
		{
			const { roomId, user } = action.payload;
			const rooms = state.rooms.map((el) =>
			{
				if (el.id === roomId)
				{
					return { ...el, users: [...el.users.filter((u) => u.id !== user?.id), user] };
				}
				else
				{
					return { ...el, users: el.users.filter((u) => u.id !== user?.id) };
				}
			});

			return { ...state, rooms };
		}

		case 'LEAVE_BREAKOUT_ROOM':
		{
			const { userId } = action.payload;
			const rooms = state.rooms.map((el) =>
			{
				return { ...el, users: el.users && el.users.length > 0 ? el.users.filter((u) => u.id !== userId) : [] };
			});

			return { ...state, rooms };
		}

		case 'CLEAR_ALL_BREAKOUT_ROOMS':
		{
			return { ...state, rooms: [] };
		}

		case 'UPDATE_BREAKOUT_ROOM_SETTINGS':
		{
			const { settings } = action.payload;

			return { ...state, settings };
		}

		case 'SET_BREAKOUT_ROOM_TIME_LIMIT':
		{
			const { timeLimit } = action.payload;

			return { ...state, timeLimit };
		}

		case 'UPDATE_ROOM_USERS_ASSIGN_BREAKOUT_ROOM':
		{
			const { userId, breakoutRoom } = action.payload;

			return { ...state, users: state.users.map((u) => (u.id === userId ? ({ ...u, assignedRoom: breakoutRoom }) : u)) };
		}

		default:
			return state;
	}
};

export default breakoutRoom;